export const MediaUserPermissionStatus = {
	DENIED: 'DENIED',
	GRANTED: 'GRANTED',
	INITIAL: 'INITIAL',
	PROMPT: 'PROMPT',
};
